export default __webpack_public_path__ + "media/bundles/App/layout/icon/svgs/spinner-fa11536fe92ecc14dc62d2f4c3fc9848.svg";